import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter,
    ViewEncapsulation,
    OnChanges,
    SimpleChanges,
} from '@angular/core';
import { comparator } from '@fi-shared/utils/array-sort-comparators';
import { SideListModel } from './side-list.model';
import { ContentLanguagesService } from '../fi-services/content-languages.service';
import { FiSideListType } from './side-list-type';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { IContentLanguage } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';
import { GetPropertyByString } from '@fi-shared/fi-shared-services/extensions.service';

@Component({
    selector: 'fi-side-list',
    template: `
        @if (languageVersionTextId) {
          <div class="language-version">
            {{ languageVersionTextId | fiAppText }}
          </div>
        }
        <div class="CcmSideList">
          @for (data of ccmSideList.Data; track data) {
            <div
              (click)="ChangeItem(GetValue(data))"
                [ngClass]="{
                    BrandedBorderColor: IsSelected(GetValue(data)),
                    Toggled: IsSelected(GetValue(data)),
                    Default: IsDefaultItem(GetValue(data)),
                }"
              class="CcmSideListItem"
              >
              <span class="CcmSideListItemText">
                {{ GetTextToDisplay(data) }}
              </span>
            </div>
          }
        </div>
        `,
    styleUrls: ['./side-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-side-list' },
    standalone: false,
})
export class SideListComponent implements OnInit, OnChanges {
    @Input() ccmSideList: SideListModel;
    @Input() ngModel: number;
    @Input() languageVersionTextId: string;
    @Output() ngModelChange = new EventEmitter<number>();

    constructor(
        private contentLanguagesService: ContentLanguagesService,
        private userDataService: FiUserDataService,
    ) {}

    ngOnInit() {
        let defaultContentLanguageId = this.userDataService.getContentLanguage();
        if (!this.ccmSideList) {
            this.ccmSideList = new SideListModel(
                FiSideListType.Translations,
                this.userDataService.applicationLanguage,
                defaultContentLanguageId,
            );
            this.ccmSideList.Data = this.contentLanguagesService
                .GetContentLanguages()
                .sort(comparator((item) => item.SortIndex));
            this.ccmSideList.DefaultItem = defaultContentLanguageId;
        } else {
            defaultContentLanguageId = this.ccmSideList.DefaultItem;
        }

        if (this.ngModel) {
            this.ccmSideList.ActiveItem = this.ngModel;
        } else {
            setTimeout(() => this.ChangeItem(defaultContentLanguageId));
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.ccmSideList && changes.ngModel) {
            this.ccmSideList.ActiveItem = this.ngModel;
        }
    }

    ChangeItem(item: number) {
        this.ngModelChange.emit(item);
        this.ccmSideList.ActiveItem = item;
    }

    IsSelected(item: number) {
        return this.ccmSideList.ActiveItem === item;
    }

    IsDefaultItem(item: number) {
        return this.ccmSideList.DefaultItem === item;
    }

    GetTextToDisplay(data: IContentLanguage) {
        return GetPropertyByString(data, this.ccmSideList.DataTextField);
    }

    GetValue(data: IContentLanguage) {
        return GetPropertyByString(data, this.ccmSideList.DataValueField);
    }

    getSelectedItem() {
        let i;
        for (i = 0; i < this.ccmSideList.Data.length; i++) {
            const data = this.ccmSideList.Data[i];
            if (this.GetValue(data) == this.ngModel) {
                return data;
            }
        }
    }
}
